import { render, staticRenderFns } from "./bym_PriviVIP.vue?vue&type=template&id=3a7b06e4&scoped=true"
import script from "./bym_PriviVIP.vue?vue&type=script&lang=js"
export * from "./bym_PriviVIP.vue?vue&type=script&lang=js"
import style0 from "./bym_PriviVIP.vue?vue&type=style&index=0&id=3a7b06e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b06e4",
  null
  
)

export default component.exports